import { Predicate } from 'olympe';
import AHPValue from '../../../../models/AHPValue';
import Observation from '../../../../models/Observation';

/**
 * Returns the evaluation's value of the inspection
 * @param {Observation} observation
 * @return {?number}
 */
export const getEvaluationValueOfInspection = (observation) => {
    return observation
        .followSingle(Observation.evalutationRel)
        .executeFromCache()?.getValue() ?? null;
};

/**
 * @param {Aspect} aspect
 * @param {InspectionEntity} item
 * @returns {string[]}
 */
export const fetchAhpValue = (aspect, item) => {
    return (
        item
            .follow(AHPValue.itemRel.getInverse())
            .andReturn()
            .follow(AHPValue.aspectRel)
            .filter(Predicate.in(aspect))
            .executeFromCache()
            .getFirst()
            ?.getValue() ?? 0
    );
};
